import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

export const DeleteLoanerInventoryItem = ({
  loanerInventoryItem,
  onDelete,
  text="Delete"
}) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
       text==="Delete"?
    new rest.LoanerInventoryService(loanerInventoryItem.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete(loanerInventoryItem)
        dispatch(showSuccessToast('Success', 'Loaner items ' + text+ 'Successful.'))
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      }):
          new rest.LoanerInventoryService(loanerInventoryItem.url)
      .cancel()
      .then((response) => {
        onDelete(loanerInventoryItem)
        dispatch(showSuccessToast('Success', 'Loaner items ' + text+ 'Successful.'))
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body={`Are you sure you want to mark this Loaner Inventory  item ${text}?`}
        confirmText={`Confirm ${text} Loaner Inventory  Item`}
        confirmBSStyle="danger"
        title={`${text} Loaner Inventory  Item`}
      >
        <ReactBootstrap.Dropdown.Item variant="dark" eventKey="1">
            {text==="Delete"?components.ICONS.DELETE: components.ICONS.RETURN} {text}
        </ReactBootstrap.Dropdown.Item>
      </components.Confirm>
    </>
  )
}
